var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1307 0.72041L18.9711 2.56082C19.433 3.02277 19.6923 3.64882 19.6923 4.30195V18.0513C19.6923 18.9579 18.9579 19.6923 18.0513 19.6923H1.64103C0.734359 19.6923 0 18.9579 0 18.0513V1.64103C0 0.734359 0.734359 0 1.64103 0H3.28205V4.92308H14.7692V0H15.3904C16.0435 0 16.6695 0.259282 17.1307 0.72041ZM3.28205 16.4103H16.4103V8.15097H3.28205V16.4103Z",
    fill: "#21CEB4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.666,
    y: 0.000106812,
    width: 2.46154,
    height: 3.28205,
    fill: "#21CEB4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.92383,
    y: 9.84625,
    width: 9.84615,
    height: 1.64103,
    fill: "#21CEB4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.92383,
    y: 13.1283,
    width: 9.84615,
    height: 1.64103,
    fill: "#21CEB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6b961c62.svg";
export { ForwardRef as ReactComponent };